import {useContext, useEffect, useState} from 'react';
import queryString from "query-string";
import {APIContext, defineBackend} from "./Globals.tsx";
import {Modal} from "./Modal.tsx";

export default function Redirect(){
  const [modal, setModal] = useState(null)
  const {signInDropIn} = useContext(APIContext);

  function handleRedirect(backend){
    const params = queryString.parse(window.location.search);

    let {payment_intent, payment_intent_client_secret, redirect_status, course, redirect} = params;

    if(redirect_status){
      signInDropIn(backend, payment_intent, course).then(e => {
        const url = new URL(window.location.href);
        const paramsToRemove = ['payment_intent', 'payment_intent_client_secret', 'redirect_status', 'course'];
        paramsToRemove.forEach(param => url.searchParams.delete(param));
        window.history.replaceState({}, document.title, url.toString());
        setModal({body: e?.info?? "hoppla da ging etwas schief...", header: "Deine Anfrage", actionP: ()=>{
            if(redirect){
              if(!redirect.startsWith("https"))
                redirect = "https://"+redirect
              window.location.href = redirect;
            }
          }})
      });
    }
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const backendParam = queryParams.get('weex');

    let backend_ = defineBackend(backendParam);
    handleRedirect(backend_);
  }, []);

  return <div>
    <h1>Bitte warten...</h1>
    {modal && <Modal actionP={modal.actionP?? (()=>setModal(null))} actionS={() => {}} buttonP={"OK"} header={modal.header} valid={true}>{modal.body}</Modal>}
  </div>
}
